const zhCommon = {
  siteName: '国产在线观看',
  siteTagline: '高清免费影视平台',
  nav: {
    home: '首页',
    category: '分类',
    about: '关于我们',
    search: '搜索影视...',
    allCategories: '全部分类',
  },
  home: {
    heroTitle: '精选海量高清影视',
    heroSubtitle: '国产电影、电视剧、综艺、动漫全品类资源，无需下载，即点即播',
    heroCta: '开始观看',
    hotRecommend: '热门推荐',
    latestEpisodes: '最新剧集',
    varietyShows: '热播综艺',
    animeZone: '动漫专区',
    documentary: '纪录大片',
    viewAll: '查看全部',
    views: '播放',
    updateTo: '更新至',
    completed: '已完结',
    released: '已上映',
  },
  category: {
    title: '分类浏览',
    filterByYear: '按年份筛选',
    filterByRegion: '按地区筛选',
    allYears: '全部年份',
    allRegions: '全部地区',
    noResults: '暂无相关内容',
    resultCount: '共 {{count}} 部作品',
  },
  article: {
    director: '导演',
    actors: '主演',
    region: '地区',
    year: '年份',
    episodes: '集数',
    rating: '评分',
    views: '播放量',
    tags: '标签',
    description: '剧情简介',
    relatedVideos: '猜你喜欢',
    backToList: '返回列表',
    updateInfo: '更新状态',
  },
  about: {
    title: '关于我们',
    brandIntro: '品牌介绍',
    brandDesc: '国产在线观看是一个专注于国产影视内容的在线观看平台。我们致力于为观众提供最新、最全、最高清的国产影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。\n\n自成立以来，我们始终坚持"内容为王、用户至上"的理念，通过先进的技术架构和优质的服务体验，为数百万用户带来便捷、流畅的在线观影体验。\n\n我们的内容团队每日更新最新资源，确保用户第一时间观看到心仪的国产剧集和电影。',
    reputation: '口碑与荣誉',
    reputationItems: [
      { title: '500万+', desc: '日活跃用户' },
      { title: '10万+', desc: '影视资源库' },
      { title: '99.9%', desc: '服务可用率' },
      { title: '4.8分', desc: '用户满意度' },
    ],
    partners: '合作伙伴',
    contactTitle: '联系我们',
    contactDesc: '如有任何问题或建议，欢迎通过以下方式联系我们',
    email: '电子邮箱',
    phone: '客服电话',
    address: '公司地址',
    addressText: '北京市朝阳区建国路88号SOHO现代城A座',
    formName: '姓名',
    formEmail: '邮箱',
    formMessage: '留言',
    formSubmit: '提交留言',
    formSuccess: '留言提交成功，我们会尽快回复您！',
    formError: '提交失败，请稍后重试',
  },
  footer: {
    copyright: '© 2024 国产在线观看 版权所有',
    privacy: '隐私政策',
    terms: '服务条款',
    disclaimer: '本站所有资源均来自互联网，仅供交流学习使用',
  },
  videoCard: {
    play: '立即观看',
    detail: '查看详情',
  },
  breadcrumb: {
    home: '首页',
    category: '分类',
    about: '关于我们',
  },
};

export default zhCommon;